import {
  GET_CUSTOMERS_REQUEST,
  GET_CUSTOMERS_SUCCESS,
  GET_CUSTOMERS_FAILURE,
  GET_CUSTOMER_LINEITEMS_LOOKUP_REQUEST,
  GET_CUSTOMER_LINEITEMS_LOOKUP_SUCCESS,
  GET_CUSTOMER_LINEITEMS_LOOKUP_FAILURE,
  GET_CUSTOMER_ADDRESSES_REQUEST,
  GET_CUSTOMER_ADDRESSES_SUCCESS,
  GET_CUSTOMER_ADDRESSES_FAILURE,
  ADD_UPDATE_CUSTOMER_LINE_ITEM_REQUEST,
  ADD_UPDATE_CUSTOMER_LINE_ITEM_SUCCESS,
  ADD_UPDATE_CUSTOMER_LINE_ITEM_FAILURE,
  ADD_UPDATE_CUSTOMER_ADDRESS_REQUEST,
  ADD_UPDATE_CUSTOMER_ADDRESS_SUCCESS,
  ADD_UPDATE_CUSTOMER_ADDRESS_FAILURE,
  ADD_UPDATE_CUSTOMER_DETAILS_REQUEST,
  ADD_UPDATE_CUSTOMER_DETAILS_SUCCESS,
  ADD_UPDATE_CUSTOMER_DETAILS_FAILURE,
} from "./actionTypes";
import { Customer, CustomerAddress, CustomerLineItem } from "./types";

export const getCustomersRequest = (url: string) => ({
  type: GET_CUSTOMERS_REQUEST,
  url,
});

export const getCustomersSuccess = (customers: Customer[]) => ({
  type: GET_CUSTOMERS_SUCCESS,
  payload: { customers },
});

export const getCustomersFailure = (error: string) => ({
  type: GET_CUSTOMERS_FAILURE,
  payload: { error },
});

export const getCustomerLineItemsLookupRequest = (
  url: string,
  customerId: number,
) => ({
  type: GET_CUSTOMER_LINEITEMS_LOOKUP_REQUEST,
  url,
  customerId,
});

export const getCustomerLineItemsLookupSuccess = (
  customerId: number,
  customerLineItems: CustomerLineItem[],
) => ({
  type: GET_CUSTOMER_LINEITEMS_LOOKUP_SUCCESS,
  payload: { customerId, customerLineItems },
});

export const getCustomerLineItemsLookupFailure = (error: string) => ({
  type: GET_CUSTOMER_LINEITEMS_LOOKUP_FAILURE,
  payload: { error },
});

export const getCustomerAddressesRequest = (
  url: string,
  customerId: number,
) => ({
  type: GET_CUSTOMER_ADDRESSES_REQUEST,
  url,
  customerId,
});

export const getCustomerAddressesSuccess = (
  customerId: number,
  customerAddresses: CustomerAddress[],
) => ({
  type: GET_CUSTOMER_ADDRESSES_SUCCESS,
  payload: { customerId, customerAddresses },
});

export const getCustomerAddressesFailure = (error: string) => ({
  type: GET_CUSTOMER_ADDRESSES_FAILURE,
  payload: { error },
});

export const addUpdateCustomerLineItemRequest = (
  url: string,
  payload: any,
  callback: unknown,
) => ({
  type: ADD_UPDATE_CUSTOMER_LINE_ITEM_REQUEST,
  url,
  payload,
  callback,
});

export const addUpdateCustomerLineItemSuccess = (successMessage: string) => ({
  type: ADD_UPDATE_CUSTOMER_LINE_ITEM_SUCCESS,
  payload: { successMessage },
});

export const addUpdateCustomerLineItemFailure = (error: string) => ({
  type: ADD_UPDATE_CUSTOMER_LINE_ITEM_FAILURE,
  payload: { error },
});

export const addUpdateCustomerAddressRequest = (
  url: string,
  payload: any,
  callback: unknown,
) => ({
  type: ADD_UPDATE_CUSTOMER_ADDRESS_REQUEST,
  url,
  payload,
  callback,
});

export const addUpdateCustomerAddressSuccess = (successMessage: string) => ({
  type: ADD_UPDATE_CUSTOMER_ADDRESS_SUCCESS,
  payload: { successMessage },
});

export const addUpdateCustomerAddressFailure = (error: string) => ({
  type: ADD_UPDATE_CUSTOMER_ADDRESS_FAILURE,
  payload: { error },
});

export const addUpdateCustomerDetailsRequest = (
  url: string,
  payload: any,
  callback: unknown,
) => ({
  type: ADD_UPDATE_CUSTOMER_DETAILS_REQUEST,
  url,
  payload,
  callback,
});

export const addUpdateCustomerDetailsSuccess = (successMessage: string) => ({
  type: ADD_UPDATE_CUSTOMER_DETAILS_SUCCESS,
  payload: { successMessage },
});

export const addUpdateCustomerDetailsFailure = (error: string) => ({
  type: ADD_UPDATE_CUSTOMER_DETAILS_FAILURE,
  payload: { error },
});
